import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Tag } from "antd";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import ApiService from "../../../core/service/api-service";

export default function StudyAutoExportHistoryGrid({ studyId }) {
    const { t } = useTranslation();
    const { setData, setPaginationResult, queryModel, setDataGridProps } = useDataGrid();

    const columns = [
        {
            title: t('Rule Name'),
            dataIndex: ['autoExportRule', 'name'],
            key: 'ruleName',
            render: (text, row) => row?.autoExportRuleName || '-',
        },
        {
            title: t('Target AE Title'),
            dataIndex: 'targetAeTitle',
            key: 'targetAeTitle',
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                if (status === 1) {
                    return <Tag color='green'>{t('Success')}</Tag>;
                }
                return <Tag color='red'>{t('Error')}</Tag>;
            }
        },
        {
            title: t('Error Message'),
            dataIndex: 'errorMessage',
            key: 'errorMessage',
            ellipsis: true,
            render: (text) => text || '-'
        },
        {
            title: t('Exported At'),
            dataIndex: 'exportedAt',
            key: 'exportedAt',
            render: (text) => text ? new Date(text).toLocaleString() : '-'
        },
    ];

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: columns,
        });
    }, []);

    const loadData = async () => {
        const response = await ApiService.AutoExport.GetHistoryByStudy(studyId);
        if (response.success) {
            setData(response.data);
            setPaginationResult(response.pagination);
        }
    };

    useEffect(() => {
        loadData();
    }, [queryModel.updateKey]);

    return (
        <DataGrid name={'study-auto-export-history'} />
    );
}
